import { createGroup } from "@/api/api";
import { pathes } from "@/routing/pathes";
import { useRequest } from "ahooks";
import { message } from "antd";
import { useNavigate } from "react-router-dom";

const useCreateGroup = ({groupName}:{groupName: string}) => {
    const navigate = useNavigate();

    const { run: fetchGroup } = useRequest(createGroup, {
        manual: true,
        onSuccess: () => {
            navigate(pathes.MY_GROUPS)
            message.success(`گروه ${groupName} با موفقیت ایجاد شد`)
        }
    })
    return { fetchGroup };
}
 
export default useCreateGroup;